<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m7 21c-.55 0-1.02083-.1958-1.4125-.5875s-.5875-.8625-.5875-1.4125v-13h-1v-2h5v-1h6v1h5v2h-1v13c0 .55-.1958 1.0208-.5875 1.4125s-.8625.5875-1.4125.5875zm10-15h-10v13h10zm-8 11h2v-9h-2zm4 0h2v-9h-2z"
    />
  </svg>
</template>
